import OspreyImagesCreate from './images-create'
import OspreyImagesGetById from './images-get-by-id'
import OspreyImagesGetThumbnails from './images-get-thumbnails'
import OsperyImagesMetadata from './images-metadata'
import OspreyImagesRemoveFromSilosShare from './images-silos-remove'
import OspreyImagesRemoveFromAffiliationsShare from './images-affiliations-remove'
import OspreyImagesShareToAffiliations from './images-affiliations-share'
import OspreyImagesShareToSilos from './images-silos-share'
import OspreyImagesSearch from './images-search'
import OspreyImagesSearchSuggestion from './images-search-suggestion'
import OspreyImagesTagsApply from './images-tags-apply'
import OspreyImagesTagsRemove from './images-tags-remove'
import OspreyImagesUpdate from './images-update'

export default class Images {
    create(dataKey) {
        return new OspreyImagesCreate(dataKey)
    }

    search(dataKey) {
        return new OspreyImagesSearch(dataKey)
    }

    getSearchSuggestion(dataKey) {
        return new OspreyImagesSearchSuggestion(dataKey)
    }

    getMetadata() {
        return new OsperyImagesMetadata()
    }

    getById(dataKey) {
        return new OspreyImagesGetById(dataKey)
    }

    getThumbnails(dataKey) {
        return new OspreyImagesGetThumbnails(dataKey)
    }

    applyTagToImage(dataKey) {
        return new OspreyImagesTagsApply(dataKey)
    }

    removeTagFromImage(dataKey) {
        return new OspreyImagesTagsRemove(dataKey)
    }

    shareToSilos(dataKey) {
        return new OspreyImagesShareToSilos(dataKey)
    }

    removeFromSilosShare(dataKey) {
        return new OspreyImagesRemoveFromSilosShare(dataKey)
    }

    shareToAffiliations(dataKey) {
        return new OspreyImagesShareToAffiliations(dataKey)
    }

    removeFromAffiliationsShare(dataKey) {
        return new OspreyImagesRemoveFromAffiliationsShare(dataKey)
    }

    update(dataKey) {
        return new OspreyImagesUpdate(dataKey)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/index.js